import { Anchor, Table, Text } from '@mantine/core';
import { Link } from 'react-router';
import type { Shema } from '../api/odjemalec';
import { denar } from '../oblika/oblika';

/** Stopnja DDV za prikaz: 22 → »22 %«, 9.5 → »9,5 %«. */
const ddv = (s?: number | null) => (s === undefined || s === null ? '' : `${String(s).replace('.', ',')} %`);

/** Storitve na računu ali predračunu; na telefonu se tabela pomika v okvirju. */
export function TabelaStoritev({ storitve }: { storitve: Shema['PostavkaStoritve'][] }) {
  if (storitve.length === 0) {
    return (
      <Text size="sm" c="dimmed">
        Brez storitev.
      </Text>
    );
  }
  return (
    <Table.ScrollContainer minWidth={480}>
      <Table className="stevilke" verticalSpacing={6}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Storitev</Table.Th>
            <Table.Th ta="right">Enota</Table.Th>
            <Table.Th ta="right">Kol.</Table.Th>
            <Table.Th ta="right">DDV</Table.Th>
            <Table.Th ta="right">Za plačilo</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {storitve.map((s) => (
            <Table.Tr key={s.id}>
              <Table.Td>{s.naziv}</Table.Td>
              <Table.Td ta="right" className="brez-preloma">
                {denar(s.cenaEnote)}
              </Table.Td>
              <Table.Td ta="right" className="brez-preloma">
                {String(s.kolicina ?? '').replace('.', ',')}
              </Table.Td>
              <Table.Td ta="right" className="brez-preloma">
                {ddv(s.ddvStopnja)}
              </Table.Td>
              <Table.Td ta="right" className="brez-preloma">
                {denar(s.cena)}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}

/** Vozila (artikli) na računu ali predračunu; znamka vodi na podrobnosti vozila. */
export function TabelaArtiklov({ vozila }: { vozila: Shema['PostavkaVozila'][] }) {
  if (vozila.length === 0) {
    return (
      <Text size="sm" c="dimmed">
        Brez artiklov.
      </Text>
    );
  }
  return (
    <Table.ScrollContainer minWidth={640}>
      <Table className="stevilke" verticalSpacing={6}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Znamka</Table.Th>
            <Table.Th>Tip</Table.Th>
            <Table.Th>VIN</Table.Th>
            <Table.Th ta="right">Cena</Table.Th>
            <Table.Th ta="right">DDV</Table.Th>
            <Table.Th ta="right">Za plačilo</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {vozila.map((v) => (
            <Table.Tr key={v.id}>
              <Table.Td>
                {v.voziloId ? (
                  <Anchor component={Link} to={`/vozila/${v.voziloId}`} fw={600}>
                    {v.znamka}
                  </Anchor>
                ) : (
                  v.znamka
                )}
              </Table.Td>
              <Table.Td>{v.tip}</Table.Td>
              <Table.Td>{v.vin}</Table.Td>
              <Table.Td ta="right" className="brez-preloma">
                {denar(v.cenaVozila)}
              </Table.Td>
              <Table.Td ta="right" className="brez-preloma">
                {ddv(v.ddvStopnja)}
              </Table.Td>
              <Table.Td ta="right" className="brez-preloma">
                {denar(v.cena)}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
